import api from './axiosConfig';
import { DropdownItem } from '../types';

export const masterApi = {
  getGenders: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/genders');
    return response.data;
  },
  getBloodGroups: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/bloodgroups');
    return response.data;
  },
  getMaritalStatus: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/maritalstatus');
    return response.data;
  },
  getNationality: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/nationality');
    return response.data;
  },
  getReligion: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/religion');
    return response.data;
  },
  getCategory: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/category');
    return response.data;
  },
  getEmployeeStatus: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/employeestatus');
    return response.data;
  },
  getEmploymentType: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/employmenttype');
    return response.data;
  },
  getDepartments: async (branchId?: string): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/departments', {
      params: branchId ? { branchId } : undefined,
    });
    return response.data;
  },
  getDesignations: async (departmentId?: string): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/designations', {
      params: departmentId ? { departmentId } : undefined,
    });
    return response.data;
  },
  getBranches: async (organizationId?: string): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/branches', {
      params: organizationId ? { organizationId } : undefined,
    });
    return response.data;
  },
  getShifts: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/shifts');
    return response.data;
  },
  getRelationships: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/relationships');
    return response.data;
  },
  getDocumentTypes: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/documenttypes');
    return response.data;
  },
  getAttendanceTypes: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/attendancetypes');
    return response.data;
  },
  getCountries: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/countries');
    return response.data;
  },
  getStates: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/states');
    return response.data;
  },
  getCities: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/cities');
    return response.data;
  },
  getRoles: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/roles');
    return response.data;
  },
  getEmployeeProfileRoles: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/master/employee-profile-roles');
    return response.data;
  },
  getEmployeesByRole: async (roleId: string): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>(`/employees/by-role/${roleId}`);
    return response.data;
  },
  getManagers: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/employees/managers');
    return response.data;
  },
  getHRManagers: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/employees/hr');
    return response.data;
  },
  getMentors: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/employees/mentors');
    return response.data;
  },
  getReviewers: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/employees/reviewers');
    return response.data;
  },
  getSalaryStructures: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/payroll/salarystructures');
    return response.data;
  },
  getEmailGroups: async (): Promise<DropdownItem[]> => {
    const response = await api.get<DropdownItem[]>('/email/groups');
    return response.data;
  },
};
